import { installSteps } from '@/pages/home/data';

export default function InstallSteps() {
  return (
    <section id="steps" className="scroll-mt-20 bg-background-50">
      <div className="max-w-[1240px] mx-auto px-4 md:px-6 py-14 md:py-20">
        <div className="max-w-2xl">
          <p className="text-xs font-medium tracking-[0.24em] text-primary-600">INSTALL STEPS</p>
          <h2 className="mt-2 font-heading font-bold text-2xl md:text-3xl text-foreground-950">
            安卓版安装步骤，一步一步跟着走
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 leading-relaxed">
            从开启权限到打开使用，共五个步骤。遇到问题时可以直接对照下方常见问题排查。
          </p>
        </div>

        <div className="mt-9 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {installSteps.map((step) => (
            <div
              key={step.step}
              className="relative bg-background-50 border border-background-200 rounded-xl p-5 hover:border-primary-300 transition-colors"
            >
              <span className="absolute top-4 right-4 font-heading font-bold text-2xl text-background-300">
                {step.step}
              </span>
              <span className="w-11 h-11 rounded-lg bg-primary-100 text-primary-700 flex items-center justify-center">
                <i className={`${step.icon} text-xl`}></i>
              </span>
              <h3 className="mt-4 font-heading font-bold text-base text-foreground-950">{step.title}</h3>
              <p className="mt-2 text-xs leading-relaxed text-foreground-500">{step.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}